import { getApi } from 'api';
import { AxiosError, AxiosResponse } from 'axios';
import {
  ImpactDto,
  PolicyErrorDetails,
  PolicyUnit,
  ProposedUnitState,
  TimeRegistrationPolicyView,
  UnitState,
} from 'types/time-registration-policy/ITimeRegistrationPolicy';

const BASE_URL = 'TimeRegistrationPolicy';
const SAVE_TIMEOUT_MS = 30000;

interface PolicyErrorBody {
  error?: string;
  message?: string | null;
  details?: PolicyErrorDetails;
}

export interface ParsedPolicyError {
  key: string | null;
  details: PolicyErrorDetails;
  status?: number;
  timedOut: boolean;
}

export const parsePolicyError = (error: unknown): ParsedPolicyError => {
  const axiosError = error as AxiosError<PolicyErrorBody>;
  return {
    key: axiosError?.response?.data?.error ?? null,
    details: axiosError?.response?.data?.details ?? {},
    status: axiosError?.response?.status,
    timedOut: axiosError?.code === 'ECONNABORTED' || (!!axiosError?.request && !axiosError?.response),
  };
};

const unitRoute = (unit: PolicyUnit): string => `${BASE_URL}/${PolicyUnit[unit]}`;

export const getTimeRegistrationPolicy = async (): Promise<TimeRegistrationPolicyView> => {
  const response: AxiosResponse<TimeRegistrationPolicyView> = await getApi().get(BASE_URL);
  return response.data;
};

export const getPolicyImpact = async (unit: PolicyUnit, proposed: ProposedUnitState): Promise<ImpactDto> => {
  const response: AxiosResponse<ImpactDto> = await getApi().post(`${unitRoute(unit)}/Impact`, proposed);
  return response.data;
};

export const putPolicyUnit = async (
  unit: PolicyUnit,
  expected: ProposedUnitState,
  proposed: ProposedUnitState,
): Promise<UnitState> => {
  const response: AxiosResponse<UnitState> = await getApi().put(
    unitRoute(unit),
    { expected, proposed },
    { timeout: SAVE_TIMEOUT_MS },
  );
  return response.data;
};
